// extracted by mini-css-extract-plugin
module.exports = {"header":"ChooseProperty_style_header__1Vqks","list":"ChooseProperty_style_list__1ujLp","item":"ChooseProperty_style_item__2z2hR"};